import { DesignSystem } from '@workbuddy/ui/v2/design-system';

const tokens = DesignSystem.tokens;
const utility = tokens.componentColors.utility;
export const listRowCellStyleId = 'wb-v2-list-row-cell-theme';

/**
 * Token bridge for list-row-cell (entity board list leaf rows).
 * DesignTokens → --local-* only; LESS must not reference --wb-*.
 */
export const listRowCellBridgeStyles = {
  'list-row-cell': {
    '--local-list-row-font-family': tokens.font.family.body,
    '--local-list-row-font-size': tokens.font.size.textSm,
    '--local-list-row-line-height': tokens.lineHeight.textSm,
    '--local-list-row-text': tokens.color.text.primary,
    '--local-list-row-text-secondary': tokens.color.text.secondary,
    '--local-list-row-text-tertiary': tokens.color.text.tertiary,
    '--local-list-row-font-weight-medium': tokens.font.weight.medium,
    '--local-list-row-avatar-bg': tokens.color.background.tertiary,
    '--local-list-row-avatar-size': '24px',
    '--local-list-row-avatar-font-size': '11px',
    '--local-list-row-avatar-border': tokens.color.border.secondary,
    '--local-list-row-gap': tokens.spacing.md,
    '--local-list-row-left-gap': tokens.spacing.sm,
    '--local-list-row-parent-gap': tokens.spacing.xs,
    '--local-list-row-parent-divider-size': tokens.font.size.textXs,
    '--local-list-row-title-adornment': tokens.color.foreground.secondary,
    '--local-list-row-title-adornment-error': tokens.color.foreground.errorSecondary,
    '--local-list-row-title-adornment-size': tokens.font.size.textSm,
    '--local-list-row-title-adornment-compact-size': '8px',
    '--local-list-row-parent-progress-bg': 'transparent',
    '--local-list-row-right-gap': tokens.spacing.sm,
    '--local-list-row-fixed-gap': tokens.spacing.xs,
    '--local-list-row-trailing-gap': tokens.spacing.xs,
    '--local-list-row-padding-inline': tokens.spacing.lg,
    '--local-list-row-nested-connector-width': tokens.spacing.xl,
    '--local-list-row-nested-connector-height': '40px',
    '--local-list-row-nested-connector-stroke': '1.5px',
    '--local-list-row-nested-connector-color': utility.gray200,
    // Title keeps a small floor; the property bag uses every remaining pixel before collapsing.
    '--local-list-row-left-min-width': '96px',
    // Property bag — never collapse to 0 (that was "only Aug 13" visible).
    '--local-list-row-bag-min-width': '72px',
    '--local-list-row-bag-max-width': 'none',
    '--local-list-row-bag-value-max-width': 'none',
    '--local-list-row-property-bg': tokens.color.background.primary,
    '--local-list-row-property-border': tokens.color.border.secondary,
    '--local-list-row-property-text': tokens.color.text.secondary,
    '--local-list-row-property-success': tokens.color.foreground.successSecondary,
    '--local-list-row-property-success-bg': tokens.color.background.successPrimary,
    '--local-list-row-property-muted-bg': tokens.color.background.secondary,
    '--local-list-row-property-muted-border': tokens.color.border.primary,
    // Brand: an informational chip that is neither good news nor a warning — a record deviating from
    // its plan, for instance. Blue is reserved for that, so a status never borrows it.
    '--local-list-row-property-brand': tokens.color.foreground.brandSecondary,
    '--local-list-row-property-brand-bg': tokens.color.background.brandPrimary,
    '--local-list-row-property-brand-border': tokens.color.border.brand,
    '--local-list-row-property-warning': tokens.color.foreground.warningSecondary,
    '--local-list-row-property-warning-bg': tokens.color.background.warningPrimary,
    '--local-list-row-property-warning-border': tokens.color.background.warningSecondary,
    '--local-list-row-property-error': tokens.color.foreground.errorSecondary,
    '--local-list-row-property-error-bg': tokens.color.background.errorPrimary,
    '--local-list-row-property-error-border': tokens.color.border.errorSubtle,
    '--local-list-row-property-borderless-border': 'transparent',
    '--local-list-row-property-disabled': tokens.color.foreground.disabled,
    '--local-list-row-property-disabled-opacity': '0.55',
    '--local-list-row-due-overdue-bg': tokens.color.background.errorPrimary,
    '--local-list-row-due-overdue-text': tokens.color.foreground.errorSecondary,
    '--local-list-row-due-overdue-border': tokens.color.border.errorSubtle,
    '--local-list-row-due-soon-bg': utility.orangeDark50,
    '--local-list-row-due-soon-text': utility.orangeDark600,
    '--local-list-row-due-soon-border': utility.orangeDark100,
    '--local-list-row-due-later-bg': tokens.color.background.primary,
    '--local-list-row-due-later-text': tokens.color.text.secondary,
    '--local-list-row-due-later-border': tokens.color.border.secondary,
    // Fixed trailing columns
    '--local-list-row-slot-assignee-width': '24px',
    '--local-list-row-slot-date-width': '48px',
    '--local-list-row-compact-padding-block': tokens.spacing.sm,
    '--local-list-row-compact-padding-inline': tokens.spacing.lg,
    '--local-list-row-narrow-padding-inline': tokens.spacing.md,
    '--local-list-row-compact-line-gap': tokens.spacing.xs,
    '--local-list-row-compact-group-gap': tokens.spacing.md,
    '--local-list-row-compact-title-only-min-height': '40px',
    '--local-list-row-compact-min-height': '64px',
    '--local-list-row-narrow-min-height': '72px',
    // Match the shared XS badge typography so dates and property pills share one baseline.
    '--local-list-row-compact-metadata-font-size': '12px',
    '--local-list-row-compact-metadata-line-height': '18px',
    '--local-list-row-compact-property-max-width': '180px',
    '--local-list-row-compact-avatar-size': '20px',
    '--local-list-row-compact-metadata-height': '20px',
  },
};
